import { Component, Input  } from '@angular/core';
import { Statistics } from '../model/statistics';
@Component({
    selector: 'statistics-component',
    template: `<div class="panel panel-default" style="padding: 10px;">
            <div class="row">
              <div class="col-md-12">
                <div class="card text-white mb-3" style="background-color: #1e365d">
                  <div class="card-header" style="border-bottom: #182b4a; border-width: 1.5px;border-bottom-style: solid; color: white; font-family: Calibri; font-size: 20px;">
                    <span><i style="font-size: 65px;color: white;" class="fas fa-chart-line"></i></span>
                  </div>
                  <div class="card-body">
                    <div *ngFor="let stat of statistics.stats" class="container">
                      <div *ngIf="stat.name.includes('Respondents')" class="tile wide resource">
                        <div class="header">
                          <div class="left">
                            <div class="count">{{stat.value}}</div>
                            <div class="title">Total</div>
                            <span><i style="color: #00b0ff;font-size: 50px;" class="fas fa-users"></i></span>
                          </div>
                          <div class="right">
                            <div class="title">{{stat.name|translate}}</div>
                          </div>
                        </div>
                        <div class="body">
                        </div>
                      </div>
                      <div *ngIf="stat.name.includes('sms')" class="tile job">
                        <div class="header">
                          <div class="count">{{stat.value}}</div>
                          <div class="title">{{stat.name|translate}}</div>
                        </div>
                        <div class="body">
                          <span><i style="font-size: 50px;" class="fas fa-comments"></i></span>
                        </div>
                      </div>
                      <div *ngIf="stat.name.includes('email')" class="tile wide quote">
                        <div class="header">
                          <div class="left">
                            <div class="count">{{stat.value}}</div>
                            <div class="title">Total</div>
                          </div>
                          <div class="right">
                            <div class="title">{{stat.name|translate}}</div>
                          </div>
                        </div>
                        <div class="body">
                          <span *ngIf="stat.name === 'emailSent'"><i style="color: #00b0ff; font-size: 50px;" class="fas fa-mail-bulk"></i></span>
                          <span *ngIf="stat.name != 'emailSent'"><i style="color: #00b0ff; font-size: 50px;" class="fas fa-envelope-open"></i></span>
                        </div>
                      </div>
                      <div *ngIf="stat.name.includes('click')" class="tile job">
                        <div class="header">
                          <div class="count">{{stat.value}}</div>
                          <div class="title">{{stat.name|translate}}</div>
                        </div>
                        <div class="body">
                          <span><i class="fas fa-comments"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--<div *ngFor="let stat of statistics.stats" class="container">
                  <div class="tile job">
                    <div class="header">
                      <div class="count">{{stat.value}}</div>
                      <div class="title">{{stat.name|translate}}</div>
                    </div>
                    <div class="body">
                      <div class="title">Awaiting Reallocation</div>
                    </div>
                  </div>
                </div>-->
                   <!-- <table class="table table-striped table-dark table-hover" >
                     <thead class="thead-dark">
                        <tr>
             <th width="90%" >{{'general'|translate}} </th>
                            <th width="10%">{{'total'|translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let stat of statistics.stats">
                            <td >{{stat.name|translate}}</td>
                            <td >{{stat.value}}</td>
                        </tr>
                        </tbody>
                    </table>-->
                    <br/>
                    <br/>
                <div class="divHeader"><span class="tableColumn clickColumn">{{'clicks'|translate}}</span><span class="tableColumn fromColumn">{{'from'|translate}}</span><span class="tableColumn totalColumn">{{'total'|translate}}</span></div>
                <div class="tableContainer">
                    <table *ngIf="statistics.clicks.length > 0" class="table table-fixed table-bordered table-sm table-hover" >
                    <thead class="table Header Bootstraap thead-dark">
                    </thead>
                    <tbody class="statTableBody">
                        <tr *ngFor="let click of statistics.clicks">
                            <td width="80%">{{click.href}}</td>
                            <td width="10%">{{click.from}}</td>
                            <td width="10%">{{click.total}}</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
              </div>
            </div>
        </div>
    `,
  styleUrls:['../../assets/css/dashboard-tiles.css']
})
export class StatisticsComponent {
    @Input()statistics:Statistics;

}
